(function () {
    'use strict';

    angular
        .module('adminReferenceDataControllers')
        .factory('LookupAttributeValueViewModelFactory', ['adminReferenceDataService', '$q', function (adminReferenceDataService, $q) {
            var service = {};

            service.CreateViewModel = function (lookupAttributeValue) {
                var value = new Object();

                value.titleEditField = "";
                value.model = lookupAttributeValue;
                value.isEditMode = _.isUndefined(lookupAttributeValue.LookupAttributeValueID);
                value.Add = function (itemTypeCode, attributeCode) {
                    var clonedModel = _.cloneDeep(this.model);

                    var actionPromise;

                    if (_.isUndefined(clonedModel.LookupAttributeValueID)) {
                        clonedModel.Value = clonedModel.TitleEN = _.cloneDeep(this.titleEditField);

                        actionPromise = adminReferenceDataService
                                        .addUserDefinedValue(itemTypeCode, attributeCode, clonedModel);
                    }
                    else {
                        clonedModel.TitleEN = _.cloneDeep(this.titleEditField);

                        actionPromise = adminReferenceDataService
                                        .updateUserDefinedValue(clonedModel.LookupAttributeValueID, clonedModel);
                    }

                    return actionPromise.then(function (data) {
                        value.model = data;
                        value.isEditMode = false;
                    }).promise;
                };

                value.Edit = function () {
                    this.titleEditField = _.cloneDeep(this.model.TitleEN);
                    this.isEditMode = true;
                };

                value.Cancel = function () {
                    this.isEditMode = false;
                    return $q.when(undefined);
                };

                value.Delete = function () {
                    if (_.isUndefined(this.model.LookupAttributeValueID)) { return; }

                    return adminReferenceDataService
                                .deleteUserDefinedValue(this.model.LookupAttributeValueID);
                };

                return value;
            };

            return service;
        }]);
})();